import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Container from "@mui/material/Container";
import MuiAlert from "@mui/material/Alert";
import Loading from "../Loading";
import { useNotification } from "../../contexts";
import TopNav from "../TopNav";
import { useLocation } from "react-router";

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

function Layout(props) {
  const { isLoading, children, className = "" } = props;

  // const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   if (
  //     notificationState.notifications &&
  //     notificationState.notifications.length
  //   ) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // }, [notificationState.notifications]);

  // useEffect(() => {
  //   if (
  //     notificationState.notifications &&
  //     notificationState.notifications.length
  //   ) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // }, [location.pathname]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <TopNav />

      <Container
        maxWidth="lg"
        sx={{
          padding: "6rem 1rem 3rem",
        }}
        className={className}
      >
        {children}
      </Container>
    </>
  );
}

export default Layout;
